/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import _ from 'lodash';
import * as lc from '../../../../../utils/lodashCustom';
import { getItemFromRefList } from '../../../../main/reducers/static/states/referenceLists/reducer';

export function restructureUserProfileForm(data) {
  return {
    username: lc.get(data, 'data.username'),
    email: lc.get(data, 'data.email'),
    phone_number: lc.get(data, 'data.phone_number'),
    test: 111
  };
}

export function restructureUserAnketaForm(data) {
  const birthDt = lc.get(data, 'birth_dt');
  return {
    name: lc.get(data, 'name'),
    gender: lc.get(data, 'gender'),
    time_zone: lc.get(data, 'time_zone'),
    date: birthDt ? moment(birthDt).date() : null,
    month: birthDt ? moment(birthDt).month() + 1 : null,
    year: birthDt ? moment(birthDt).year() : null,
    city_geoname_id: lc.get(data, 'city_geoname_id'),
    cityGeonameDesc: lc.get(data, 'city_geo_name.locale')
  };
}

export function restructureAccountFullInfo(state, data) {
  return {
    profile: {
      userId: lc.get(data, 'data.id'),
      username: lc.get(data, 'data.username'),
      email: lc.get(data, 'data.email'),
      concatRoles: lc.get(data, 'data.concat_roles'),
      authSecureType: lc.get(data, 'data.auth_secure_type'),
      fullName: lc.get(data, 'data.profile.name'),
      avatarPath: lc.get(data, 'data.profile.avatar_path'),
      createdAt: lc.get(data, 'data.created_at'),
      lastAuthAt: lc.get(data, 'data.last_auth'),
      birthDt: lc.get(data, 'data.profile.birth_dt'),
      consentToAdultContent: lc.get(
        data,
        'data.profile.consent_to_adult_content'
      ),
      birthDtYearsOld: lc.get(data, 'data.profile.birth_dt_years_old'),
      gender: lc.get(data, 'data.profile.gender'),
      timeZone: lc.get(data, 'data.profile.time_zone'),
      emailConfirm: lc.get(data, 'data.email_confirm'),
      showSettingsModal: lc.get(data, 'data.profile.show_settings_modal'),
      newEmail: lc.get(data, 'data.new_email'),
      rating: {
        rating: lc.get(data, 'data.rating_status.rating'),
        ratingStatusTitle: lc.get(data, 'data.rating_status.title'),
        ratingStatusPoints: lc.get(data, 'data.rating_status.points'),
        ratingStatusPointsFrom: lc.get(data, 'data.rating_status.points_from'),
        ratingStatusPointsTo: lc.get(data, 'data.rating_status.points_to'),
        incomeRef1Lvl: lc.get(data, 'data.rating_status.income_ref_1_lvl'),
        incomeRef2Lvl: lc.get(data, 'data.rating_status.income_ref_2_lvl')
      },
      location: {
        id: lc.get(data, 'data.profile.city_geo_name.id', null),
        countryName: lc.get(
          data,
          'data.profile.city_geo_name.country_name',
          null
        ),
        cityName: lc.get(data, 'data.profile.city_geo_name.city_name', null),
        timeZone: lc.get(data, 'data.profile.city_geo_name.time_zone', null),
        locale: lc.get(data, 'data.profile.city_geo_name.locale', null)
      },
      referrer: {
        id: lc.get(data, 'data.referrer.id', null),
        username: lc.get(data, 'data.referrer.username', null)
      },
      countsStat: {
        tasksStat: {
          countMyTasks: lc.get(data, 'data.tasks_stat.count_my_tasks'),
          countExecutionsMyTasks: lc.get(
            data,
            'data.tasks_stat.count_executions_my_tasks'
          ),
          countNewTasks: lc.get(data, 'data.tasks_stat.count_new_tasks'),
          countTasksHide: lc.get(data, 'data.tasks_stat.count_tasks_hide'),
          countTasksChosen: lc.get(data, 'data.tasks_stat.count_tasks_chosen'),
          myExecutionsStat: {
            countExecProcessed: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_processed'
            ),
            countExecAtCheckout: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_at_checkout'
            ),
            countExecRemake: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_remake'
            ),
            countExecCanceled: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_canceled'
            ),
            countExecNotDone: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_not_done'
            ),
            countExecFinished: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_finished'
            ),
            countExecDispute: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_dispute'
            ),
            countExecCanceledByTaskOwner: lc.get(
              data,
              'data.tasks_stat.my_executions.count_exec_canceled_by_task_owner'
            )
          },
          myTasksStat: {
            countActive: lc.get(data, 'data.tasks_stat.my_tasks.count_active'),
            countStopped: lc.get(
              data,
              'data.tasks_stat.my_tasks.count_stopped'
            ),
            countFinished: lc.get(
              data,
              'data.tasks_stat.my_tasks.count_finished'
            ),
            countArchive: lc.get(
              data,
              'data.tasks_stat.my_tasks.count_archive'
            ),
            countLocked: lc.get(data, 'data.tasks_stat.my_tasks.count_locked'),
            countPremoderation: lc.get(
              data,
              'data.tasks_stat.my_tasks.count_premoderation'
            ),
            countOnCorrection: lc.get(
              data,
              'data.tasks_stat.my_tasks.count_on_correction'
            )
          },
          tasksExecsStatByAccTasks: {
            countExecProcessed: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.1.count'
            ),
            countExecAtCheckout: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.2.count'
            ),
            countExecRemake: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.3.count'
            ),
            countExecFinished: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.4.count'
            ),
            countExecNotDone: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.5.count'
            ),
            countExecCanceled: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.6.count'
            ),
            countExecDispute: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.7.count'
            ),
            countExecCanceledByTaskOwner: lc.get(
              data,
              'data.count_stat.execs.my_task_execs_stat.8.count'
            )
          }
        },
        commentsIn: {
          dislikes: lc.get(data, 'data.count_stat.comments_in.dislikes'),
          likes: lc.get(data, 'data.count_stat.comments_in.likes'),
          neutral: lc.get(data, 'data.count_stat.comments_in.neutral'),
          total: lc.get(data, 'data.count_stat.comments_in.total')
        },
        commentsOut: {
          dislikes: lc.get(data, 'data.count_stat.comments_out.dislikes'),
          likes: lc.get(data, 'data.count_stat.comments_out.likes'),
          neutral: lc.get(data, 'data.count_stat.comments_out.neutral'),
          total: lc.get(data, 'data.count_stat.comments_out.total')
        },
        referrals: {
          count: lc.get(data, 'data.count_stat.referrals.count'),
          earned_amount: lc.get(data, 'data.count_stat.referrals.earned_amount')
        }
      }
    },
    balance: {
      balanceMainAccount: {
        name: lc.get(data, 'data.balance.balances.1.account_type_name'),
        sum: lc.get(data, 'data.balance.balances.1.sum')
      },
      balanceAdsAccount: {
        name: lc.get(data, 'data.balance.balances.2.account_type_name'),
        sum: lc.get(data, 'data.balance.balances.2.sum')
      },
      totalBalance: lc.get(data, 'data.balance.total_balance')
    }
  };
}

export function restructureUserFullInfo(state, data) {
  return {
    id: lc.get(data, 'id'),
    username: lc.get(data, 'username'),
    fullName: lc.get(data, 'profile.name'),
    avatarPath: lc.get(data, 'profile.avatar_path'),
    createdAt: lc.get(data, 'created_at'),
    lastAuthAt: lc.get(data, 'last_auth'),
    birthDt: lc.get(data, 'profile.birth_dt'),
    birthDtYearsOld: lc.get(data, 'profile.birth_dt_years_old'),
    gender: lc.get(data, 'profile.gender'),
    genderLabel: _.get(data, 'profile.gender')
      ? getItemFromRefList(state, 'userGanders').find(
          obj => obj.id === _.get(data, 'profile.gender')
        ).title
      : null,
    rating: {
      rating: lc.get(data, 'rating_status.rating'),
      ratingStatusTitle: lc.get(data, 'rating_status.title'),
      ratingStatusPoints: lc.get(data, 'rating_status.points'),
      ratingStatusPointsFrom: lc.get(data, 'rating_status.points_from'),
      ratingStatusPointsTo: lc.get(data, 'rating_status.points_to')
    },
    location: {
      id: lc.get(data, 'profile.city_geo_name.id', null),
      countryName: lc.get(data, 'profile.city_geo_name.country_name', null),
      cityName: lc.get(data, 'profile.city_geo_name.city_name', null),
      timeZone: lc.get(data, 'profile.city_geo_name.time_zone', null),
      locale: lc.get(data, 'profile.city_geo_name.locale', null)
    },
    referrer: {
      id: lc.get(data, 'referrer.id', null),
      username: lc.get(data, 'referrer.username', null)
    },
    countsStat: {
      tasksStat: {
        countMyTasks: lc.get(data, 'tasks_stat.count_my_tasks'),
        countExecutionsMyTasks: lc.get(
          data,
          'tasks_stat.count_executions_my_tasks'
        ),
        countNewTasks: lc.get(data, 'tasks_stat.count_new_tasks'),
        countTasksHide: lc.get(data, 'tasks_stat.count_tasks_hide'),
        countTasksChosen: lc.get(data, 'tasks_stat.count_tasks_chosen'),
        myExecutionsStat: {
          countExecProcessed: lc.get(
            data,
            'tasks_stat.my_executions.count_exec_processed'
          ),
          countExecAtCheckout: lc.get(
            data,
            'tasks_stat.my_executions.count_exec_at_checkout'
          ),
          countExecRemake: lc.get(
            data,
            'tasks_stat.my_executions.count_exec_remake'
          ),
          countExecCanceled: lc.get(
            data,
            'tasks_stat.my_executions.count_exec_canceled'
          ),
          countExecNotDone: lc.get(
            data,
            'tasks_stat.my_executions.count_exec_not_done'
          ),
          countExecFinished: lc.get(
            data,
            'tasks_stat.my_executions.count_exec_finished'
          ),
          countExecDispute: lc.get(
            data,
            'tasks_stat.my_executions.count_exec_dispute'
          )
        },
        myTasksStat: {
          countActive: lc.get(data, 'tasks_stat.my_tasks.count_active'),
          countStopped: lc.get(data, 'tasks_stat.my_tasks.count_stopped'),
          countFinished: lc.get(data, 'tasks_stat.my_tasks.count_finished'),
          countArchive: lc.get(data, 'tasks_stat.my_tasks.count_archive'),
          countLocked: lc.get(data, 'tasks_stat.my_tasks.count_locked')
        }
      },
      commentsIn: {
        dislikes: lc.get(data, 'count_stat.comments_in.dislikes'),
        likes: lc.get(data, 'count_stat.comments_in.likes'),
        neutral: lc.get(data, 'count_stat.comments_in.neutral'),
        total: lc.get(data, 'count_stat.comments_in.total')
      },
      commentsOut: {
        dislikes: lc.get(data, 'count_stat.comments_out.dislikes'),
        likes: lc.get(data, 'count_stat.comments_out.likes'),
        neutral: lc.get(data, 'count_stat.comments_out.neutral'),
        total: lc.get(data, 'count_stat.comments_out.total')
      },
      referrals: {
        count: lc.get(data, 'count_stat.referrals.count'),
        earned_amount: lc.get(data, 'count_stat.referrals.earned_amount')
      },
      tasks: {
        count: lc.get(data, 'count_stat.tasks.task_created'),
        earned_amount: lc.get(data, 'count_stat.tasks.earned_amount')
      },
      execs: {
        userExecutionsStat: lc.get(data, 'count_stat.execs.my_execs_stat'),
        executionsByUserTasksStat: lc.get(
          data,
          'count_stat.execs.my_task_execs_stat'
        )
      }
    },
    outOfMyBlackListCustomer: lc.get(data, 'outOfMyBlackListCustomer') || null,
    outOfMyBlackListExecutor: lc.get(data, 'outOfMyBlackListExecutor') || null
  };
}

export function restructureUserModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    username: lc.get(data, 'username'),
    createdAt: lc.get(data, 'created_at'),
    isMyReferrer: lc.get(data, 'isMyReferrer'),
    isMyReferral: lc.get(data, 'isMyReferral'),
    concatRoles: lc.get(data, 'concat_roles'),
    lastAuthAt: lc.get(data, 'last_auth'),
    profile: _.get(data, 'profile')
      ? {
          avatarPath: lc.get(data, 'profile.avatar_path')
        }
      : null
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/services/UserService/restructuring/index.js